import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";

const AnimationSelect = (props) => {
  const { availableAnimations = [], ...otherProps } = props;

  return (
    <TextField
      fullWidth
      select
      InputLabelProps={{ shrink: true }}
      label={props.label || "Animation Select"}
      variant="outlined"
      {...otherProps}
    >
      <MenuItem value={null}>No animation</MenuItem>
      {availableAnimations.map((el) => {
        return (
          <MenuItem key={el.id} value={el.id}>
            {el.name}
          </MenuItem>
        );
      })}
    </TextField>
  );
};

export default AnimationSelect;
